import { render, staticRenderFns } from "./CytomineQuillEditor.vue?vue&type=template&id=47c0b851"
import script from "./CytomineQuillEditor.vue?vue&type=script&lang=js"
export * from "./CytomineQuillEditor.vue?vue&type=script&lang=js"
import style0 from "./CytomineQuillEditor.vue?vue&type=style&index=0&id=47c0b851&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports